import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bdc3912"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, "风险分析")
], -1))
const _hoisted_3 = { class: "block-content" }
const _hoisted_4 = { id: "chart-board" }
const _hoisted_5 = { class: "row risk-info" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "案件数", -1))
const _hoisted_7 = { class: "num" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "risk-adorn" }, null, -1))
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("赔付金额 ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-info" }, null, -1))
const _hoisted_12 = { class: "num" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", { class: "unit" }, "¥", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "risk-adorn" }, null, -1))
const _hoisted_15 = { class: "title" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("赔付率 ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-info" }, null, -1))
const _hoisted_18 = { class: "num" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", { class: "unit" }, " %", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "risk-adorn" }, null, -1))
const _hoisted_21 = { class: "title" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("实时费率 ")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-info" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", { class: "unit" }, " %", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createVNode(_component_el_empty, null, null, 512), [
        [_vShow, _ctx.isEmpty]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
        [_vShow, !_ctx.isEmpty]
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.riskInfo.report_num), 1)
      ]),
      _hoisted_8,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: "未确定金额的案件按8000元预估",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createTextVNode(_toDisplayString(_ctx.riskInfo.report_money), 1)
        ])
      ]),
      _hoisted_14,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: "赔付金额/保费总额",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createTextVNode(_toDisplayString(Math.round(_ctx.riskInfo.pay_ratio*100)), 1),
          _hoisted_19
        ])
      ]),
      _hoisted_20,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: "价格在原始基础上的调整比例，正数为增加，负数为减少",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: _normalizeClass('num ' + (_ctx.riskInfo.premium_ratio > 1 ?'num-bad':'num-good'))
        }, [
          _createTextVNode(_toDisplayString(_ctx.riskInfo.premium_ratio >= 1 ? '+'+Math.round((_ctx.riskInfo.premium_ratio - 1)*100) : '-'+ Math.round((1 - _ctx.riskInfo.premium_ratio)*100)), 1),
          _hoisted_24
        ], 2)
      ])
    ], 512), [
      [_vShow, !_ctx.isEmpty]
    ])
  ]))
}